var map = {
	"./backgrounds/arabian-woman-overlay.jpg": 1630,
	"./backgrounds/arabian-woman.jpg": 614,
	"./backgrounds/background-1.jpg": 2654,
	"./backgrounds/busines-strategy.jpg": 9044,
	"./backgrounds/environment.jpg": 5079,
	"./backgrounds/mills-over-field.jpg": 4643,
	"./backgrounds/our-commitments-header-image.jpg": 2625,
	"./backgrounds/our-esg-strategy.jpg": 7601,
	"./backgrounds/people-taking-overlay.jpg": 3290,
	"./backgrounds/people-talking.jpg": 4194,
	"./backgrounds/saudi-green-initiative.jpg": 169,
	"./backgrounds/shore-woods-sea.jpg": 1029,
	"./backgrounds/solar-panels-header-image.jpg": 6185,
	"./backgrounds/sustainable-project.jpg": 1068,
	"./backgrounds/transition-to-net-zero.jpg": 3334,
	"./backgrounds/vision-background.jpg": 4437,
	"./cards/2022-heighlight-card.jpg": 8698,
	"./cards/business-strategy.jpg": 8904,
	"./cards/environment.jpg": 1311,
	"./cards/img-1.jpg": 1590,
	"./cards/img-2.jpg": 9212,
	"./cards/img-3.jpg": 8745,
	"./cards/img-4.jpg": 995,
	"./cards/img-5.jpg": 3984,
	"./cards/our-lnaugural-esg-report-card.jpg": 7781,
	"./cards/overarching-card.jpg": 6829,
	"./cards/project-future-card.jpg": 831,
	"./cards/resource-1.jpg": 674,
	"./cards/resource-2.jpg": 8350,
	"./cards/social-imact.jpg": 292,
	"./cards/social.jpg": 629,
	"./cards/solar-panels.jpg": 8195,
	"./cards/statements-1.jpg": 3486,
	"./cards/statements-2.jpg": 8110,
	"./cards/sustainable-financing-card-one.jpg": 3037,
	"./cards/sustainable-projects.jpg": 202,
	"./cards/sustanable.jpg": 2728,
	"./cards/transition-to-net-zero-card-two.jpg": 978,
	"./cards/transition-to-net-zero-card.jpg": 4952,
	"./cards/vision.jpg": 145,
	"./cards/water-2.jpg": 6839,
	"./cards/water-image.jpg": 1195,
	"./companies/sabb-standards.png": 3798,
	"./companies/sabb-standards.svg": 9224,
	"./companies/un.svg": 2321,
	"./companies/unep.png": 9745,
	"./companies/unep.svg": 4270,
	"./companies/united-nations.png": 5603,
	"./footer/img-1.jpg": 4722,
	"./footer/img-2.jpg": 9741,
	"./footer/img-3.jpg": 7336,
	"./footer/img-4.jpg": 7698,
	"./gallery/img-1.jpg": 3575,
	"./gallery/img-2.jpg": 9298,
	"./gallery/img-3.jpg": 622,
	"./headers/esg-profile.jpg": 6078,
	"./headers/governence.jpg": 5988,
	"./headers/insight-page-header.jpg": 6453,
	"./headers/news-page-header.jpg": 6961,
	"./headers/our-journey.jpg": 6159,
	"./headers/social.jpg": 7077,
	"./headers/sustainable.jpg": 8087,
	"./heros/hero-five.jpg": 6253,
	"./heros/mobile-log-hero.svg": 7684,
	"./insights/Climate-change-vs-environmental-protection.jpg": 8035,
	"./insights/ESG-Investing.jpg": 9250,
	"./insights/Financed-emissions.jpg": 2899,
	"./insights/Towards-environmental-sustainability-How-SAB-is-taking-action.jpg": 4679,
	"./insights/Understanding-the-evolution-of-ESG-from-niche-to-mainstream-practice.jpg": 9852,
	"./insights/emissions-ar.svg": 4879,
	"./insights/emissions.svg": 8572,
	"./insights/image-2.jpg": 2016,
	"./insights/image-3.jpg": 4043,
	"./insights/image-4.jpg": 4207,
	"./insights/image-5.jpg": 4205,
	"./insights/plan-1-ar.jpg": 3221,
	"./insights/plan-1.png": 4606,
	"./insights/why-is-sustainbaility-important.jpg": 6017,
	"./menu/commitments.jpg": 6392,
	"./menu/journey.jpg": 9215,
	"./menu/resource.jpg": 5446,
	"./menu/statements.jpg": 8181,
	"./menu/strategy.jpg": 2135,
	"./news/default.jpg": 4435,
	"./news/image-1.jpg": 5502,
	"./news/image-2.jpg": 3045,
	"./news/image-3.jpg": 57,
	"./news/news-1.jpg": 8929,
	"./news/news-3.jpg": 6569,
	"./people/ceo.jpg": 8921,
	"./people/chairman-image.jpg": 728,
	"./plans/chart-one.png": 4052,
	"./plans/embedding-graph-plan-1.svg": 3552,
	"./plans/embedding-graph-plan-ar.svg": 204,
	"./plans/embedding-graph-plan.svg": 9490,
	"./plans/emissions.svg": 3307,
	"./plans/matrix-one.jpg": 3281,
	"./plans/plan-one-ar.svg": 6326,
	"./plans/plan-one.png": 5275,
	"./plans/stakeholder-1-ar.svg": 7378,
	"./plans/stakeholder-1.svg": 3091,
	"./plans/stakeholder-2-ar.svg": 5201,
	"./plans/stakeholder-2.svg": 3974,
	"./posters/video-poster.jpg": 5191,
	"./posters/video-poster.svg": 5308,
	"./sections/compliance-1.jpg": 5050,
	"./sections/esg-governance-structure.png": 1469,
	"./sections/governence-section-one.jpg": 4691,
	"./sections/journey-1.jpg": 9197,
	"./sections/journey.jpg": 7750,
	"./sections/miles.jpg": 5193,
	"./sections/risk-management.png": 8323,
	"./sections/saudi-green.jpg": 55,
	"./sections/stakeholder-1.jpg": 675,
	"./sections/sustainable-finance-government.png": 489,
	"./sections/water-in-desert.jpg": 6734,
	"./slider/global-goal-10.svg": 3491,
	"./slider/global-goal-11.svg": 7866,
	"./slider/global-goal-12.svg": 4433,
	"./slider/global-goal-13.svg": 9666,
	"./slider/global-goal-3.svg": 555,
	"./slider/global-goal-4.svg": 8627,
	"./slider/global-goal-5.svg": 4499,
	"./slider/global-goal-7.svg": 6270,
	"./slider/global-goal-8.svg": 3075,
	"./slider/global-goal-9.svg": 2530,
	"./slider/global-goal-ar-10.svg": 1428,
	"./slider/global-goal-ar-11.svg": 4619,
	"./slider/global-goal-ar-12.svg": 4127,
	"./slider/global-goal-ar-13.svg": 9353,
	"./slider/global-goal-ar-3.svg": 3627,
	"./slider/global-goal-ar-4.svg": 9739,
	"./slider/global-goal-ar-5.svg": 6940,
	"./slider/global-goal-ar-7.svg": 6198,
	"./slider/global-goal-ar-8.svg": 6976,
	"./slider/global-goal-ar-9.svg": 6337,
	"./slider/goal1.png": 4553,
	"./slider/goal2.png": 4365,
	"./slider/goal3.png": 8737,
	"./slider/next-arrow.svg": 6849,
	"./slider/prev-arrow.svg": 8922,
	"./slider/primary-logo.svg": 1415,
	"./social/social-1.jpg": 600,
	"./social/social-2.jpg": 5316,
	"./social/social-3.jpg": 4033,
	"./social/social-4.jpg": 9023,
	"./social/social-5.jpg": 8938,
	"./social/social-6.jpg": 4588,
	"./tabs/Saudi_green_initiative_image.png": 9546,
	"./tabs/img-1.jpg": 8960,
	"./tabs/img-2.jpg": 4078,
	"./tabs/img-3.jpg": 5861,
	"./tabs/img-4.jpg": 9551,
	"./tabs/img-5.jpg": 4893,
	"./wallpaper/arabian-woman.jpg": 9208,
	"./wallpaper/business.jpg": 8726,
	"./wallpaper/commitments.jpg": 5383,
	"./wallpaper/compliance.jpg": 8015,
	"./wallpaper/csr.jpg": 329,
	"./wallpaper/embedding.jpg": 6027,
	"./wallpaper/emissions.jpg": 4113,
	"./wallpaper/environment.jpg": 9276,
	"./wallpaper/esg-profile.jpg": 1783,
	"./wallpaper/governence.jpg": 2974,
	"./wallpaper/highlight.jpg": 7422,
	"./wallpaper/international-frameworks.jpg": 739,
	"./wallpaper/journey.jpg": 3978,
	"./wallpaper/reports.jpg": 9972,
	"./wallpaper/resource.jpg": 2019,
	"./wallpaper/risk.jpg": 8669,
	"./wallpaper/saudi-green.jpg": 5101,
	"./wallpaper/stakeholders.jpg": 947,
	"./wallpaper/statements-2.jpg": 3960,
	"./wallpaper/statements.jpg": 7458,
	"./wallpaper/transtion.jpg": 3760,
	"./wallpaper/vision.jpg": 935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;